module.exports = __webpack_public_path__ + "img/avatar.03b855e9.jpg";